import { Instagram, Send, Linkedin, Youtube, Facebook } from "lucide-react";

export const WhatsAppIcon = ({ size = 17, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.31l-.34-.2-3.57.93.95-3.48-.22-.36a9.38 9.38 0 0 1-1.44-5.01c0-5.2 4.23-9.43 9.44-9.43 2.52 0 4.89.98 6.67 2.77a9.37 9.37 0 0 1 2.76 6.67c0 5.2-4.24 9.42-9.44 9.42zm8.03-17.46A11.27 11.27 0 0 0 12.05.72C5.79.72.7 5.8.7 12.06c0 2 .52 3.95 1.52 5.67L.6 23.6l6.01-1.58a11.3 11.3 0 0 0 5.43 1.38h.01c6.25 0 11.34-5.08 11.35-11.34 0-3.03-1.18-5.88-3.32-8.02z" />
  </svg>
);

export const waLink = (v) => (/^https?:\/\//.test(v) ? v : `https://wa.me/${v.replace(/\D/g, "")}`);

const ITEMS = [
  { key: "instagram", Icon: Instagram, label: "Instagram" },
  { key: "telegram", Icon: Send, label: "Telegram" },
  { key: "linkedin", Icon: Linkedin, label: "LinkedIn" },
  { key: "youtube", Icon: Youtube, label: "YouTube" },
  { key: "facebook", Icon: Facebook, label: "Facebook" },
];

const href = (key, v) => {
  if (/^https?:\/\//.test(v)) return v;
  if (key === "telegram") return `https://t.me/${v.replace(/^@/, "")}`;
  if (key === "instagram") return `https://instagram.com/${v.replace(/^@/, "")}`;
  return v;
};

export const Socials = ({ contacts = {}, className = "" }) => {
  const list = ITEMS.filter((i) => contacts[i.key]);
  if (!list.length) return null;
  return (
    <div className={`flex items-center gap-4 ${className}`} data-testid="social-links">
      {list.map(({ key, Icon, label, cls = "" }) => (
        <a key={key} href={href(key, contacts[key])} target="_blank" rel="noopener noreferrer" aria-label={label}
          data-testid={`social-${key}`} className={`opacity-80 hover:opacity-100 transition-opacity ${cls}`}>
          <Icon size={17} />
        </a>
      ))}
    </div>
  );
};
